import { useSelector } from "react-redux";
import { BasicLayout } from "../../modules/Layouts/basicLayout";
import BasicHeaderDocumentos from "./Components/BasicHeader";
import FormulariosNR from "./Components/NotaRemision/FormulariosNR";
import { State } from "../../reducers";
import { useState, useEffect } from "react";
import BasicFooterDocumentos from "./Components/BasicFooterDocument";
import ModalDelete from "../../components/Modals/Generales/ModalDelete";
import ModalEditarProducto from "./Components/NotaRemision/ModalEditarProducto";
import DTENotaRemision from "./Components/DTE/DTENotaRemision";
import ModalConfirm from "../../components/Modals/Generales/ModalConfirm";
import ModalDTEEmitido from "./Components/ModalDTEEmitido";
import ModalSendEmailDTE from "./Components/ModalSendEmailDTE";
import ModalImprimirFactura from "../../components/Modals/ModalsFacturacion/ModalImprimirFactura";
import ModalAnularDTE from "./Components/ModalAnularDTE";
import ModalClienteEncontradoDTE from "./Components/BasicModalClienteEncontradoDTE";
import ModalBuscarDocumentoDTE from "./Components/NotaRemision/ModalBuscarDocumentoDTE";
import ModalSalir from "../../components/Modals/Generales/ModalConfirmSalir";
import useComprobanteLiquidacion from "../../actions/comprobante-liquidacion";
import FormulariosCL from "./Components/NotaRemision/FormulariosCL";
import DTEComprobanteLiquidacion from "./Components/DTE/DTEComprobanteLiquidacion";
import { ModalBase } from "../../components/Modals/ModalBase";
import BasicCardDocumentos from "./Components/BasicCardDocumentos";
import InputForm from "./Components/InputFormV2";
import ModalAgregarDocumentoFisico from "./Components/NotaRemision/ModalAgregarDocumentoFisicoCL";
import { unirChipsArray } from "../../utils/strings.utils";

export default function ComprobanteLiquidacion (){
    const [imprimirComoTicket, setImprimirComoTicket] = useState(false)
    const {
        view, 
        formCliente, 
        modal_quitarTodo,
        modal_eliminar,
        modal_emitir,
        modal_emitido,
        modal_masOpciones,
        modal_enviarCorreo,
        modal_imprimir,
        modal_anulado,
        modal_anular,
        modal_clienteEncontrado,
        modal_buscarDocumentos,
        modal_agregarDocumentoFisico,
        modal_editarDocumentoFisico,

        clienteEncontrado,

        response_QRcode,
        response_Emitir,

        formBusquedaDocumento,
        errorsFormBusquedaDocumento,
        documentosEncontrados,
        documentosAsociados,
        loader_asociarDocumentos,
        mostrarDetalle
    } = useSelector((state: State) => state.comprobanteLiquidacion)
    const {
        cargarSucursales, 
        footer_textButtons, 
        footer_onClickBack, 
        footer_onClickNext, 
        button_onClickQuitarTodo, 
        modal_cerrarQuitarTodo,
        modal_cerrarModalEliminar,

        modal_button_onConfirmEliminar,
        modal_button_emitirDocumento,
        modal_cerrarEmitir,

        modal_button_emitirNuevo,
        modal_button_verDetalle,
        modal_cerrarMasOpciones,
        modal_button_cerrarModalEmitido,
        modal_button_enviarCorreo,
        modal_button_cerrarEnviarCorreo,
        modal_button_onClickEnviarCorreo,
        modal_button_descargarJson,

        modal_button_descargarExcel,
        modal_button_descargarImagen,
        modal_button_descargarPDF,
        modal_button_imprimir,
        modal_cerrarImprimir,

        modal_button_anular,
        modal_cerrarAnular,
        modal_button_onConfirmAnular,

        modal_cerrarClienteEncontrado,
        modal_button_aceptarClienteEncontrado,
        modal_button_closeWarningAsociarDocumentos,
        onChangeFormBusquedaDocumento,
        buscarDocumentosAsociados,

        actionButton_asociar,
        actionButton_desasociar,
        buttonActiveModalBusquedaDocumentos,
        modal_button_limpiarFormBusquedaDocumento,
        modal_button_imprimirTicket,
        modal_button_descargarPDFTicket,
    } = useComprobanteLiquidacion()

    const { config } = useSelector((state: State) => state.userLogin)

    return (
        <BasicLayout>
            <ModalSalir 
                excludeValidate={formCliente.loadedSucursal && (!formCliente.datosSucursal || formCliente.datosSucursal?.length == 0)} 
                title="Salir de comprobante de liquidación" 
                onConfirmExit={modal_button_emitirNuevo}
            />
            {(modal_agregarDocumentoFisico || modal_editarDocumentoFisico) && <ModalAgregarDocumentoFisico agregar = {modal_agregarDocumentoFisico}/>}
            {(modal_emitido || modal_masOpciones) && 
                <ModalDTEEmitido 
                    onClickDownloadJson={modal_button_descargarJson}
                    title = {modal_masOpciones ? 'Más opciones' : '¡Comprobante de liquidación emitido!'}
                    onClickNuevo={modal_button_emitirNuevo}
                    onClickAnular={modal_button_anular}
                    onClickCerrar={modal_masOpciones ? modal_cerrarMasOpciones : modal_button_cerrarModalEmitido}
                    onClickDownloadExcel={modal_button_descargarExcel}
                    onClickDownloadImage={modal_button_descargarImagen}
                    onClickDownloadPDF={modal_button_descargarPDF}
                    onClickEmail={modal_button_enviarCorreo}
                    onClickPrint={() => { setImprimirComoTicket(false); modal_button_imprimir() }}
                    onClickVerDetalle={modal_button_verDetalle}
                    verDetalle = {!modal_masOpciones}
                    qrImage={response_QRcode}
                    ticketHabilitado={config?.tickethabilitado}
                    onClickPrintTicket={() => { setImprimirComoTicket(true); modal_button_imprimirTicket() }}
                    onClickDownloadPDFTicket={modal_button_descargarPDFTicket}
                />
            }
            {modal_imprimir && <ModalImprimirFactura ocultarPrecio={!mostrarDetalle} documento={response_Emitir?.JsonFactura} sello={response_Emitir?.Sello} modoTicket={imprimirComoTicket} onCancel={modal_cerrarImprimir} onPrint={modal_cerrarImprimir}/>}
            {modal_enviarCorreo && <ModalSendEmailDTE chipsEmail={unirChipsArray(formCliente.chipsEmail, formCliente.email)} onClickBack={modal_button_cerrarEnviarCorreo} onClickSend={modal_button_onClickEnviarCorreo}/>}
            {modal_emitir && <ModalConfirm title = 'Emitir comprobante de liqudación' detail = '¿Estás a punto de emitir comprobante de liquidación ¿deseas continuar?' closeModalConfirm = {modal_cerrarEmitir} actionConfirm = {modal_button_emitirDocumento} messageAction = 'Emitir'/>}
            {modal_eliminar && <ModalDelete title = 'Quitar producto' detail = '¿Seguro que quieres quitar este producto? Esta acción no se puede deshacer.' closeModalDelete = {modal_cerrarModalEliminar} actionDelete = {modal_button_onConfirmEliminar}/>}
            {modal_quitarTodo && <ModalDelete title = 'Quitar todo' detail = '¿Seguro que quieres quitar todos los documentos asociados de esta lista? Esta acción no se puede deshacer.' actionDelete = {button_onClickQuitarTodo} closeModalDelete = {modal_cerrarQuitarTodo}/>}
            {modal_anular && <ModalAnularDTE title="Anular comprobante de liquidación" warning='Estás a punto de anular este comprobante de liquidación ¿deseas continuar?' onCancel={modal_cerrarAnular} actionConfirm={modal_button_onConfirmAnular}/>}
            {modal_clienteEncontrado && <ModalClienteEncontradoDTE infoCliente = {clienteEncontrado} onClickCancel = {modal_cerrarClienteEncontrado} onClickConfirm = {modal_button_aceptarClienteEncontrado}/>}
            {modal_buscarDocumentos && <ModalBuscarDocumentoDTE comprobanteLiquidacion onClickLimpiarForm={modal_button_limpiarFormBusquedaDocumento} onClickCerrar = {() => buttonActiveModalBusquedaDocumentos(false)} loader = {loader_asociarDocumentos} buttonAsociar = {actionButton_asociar} buttonDesasociar = {actionButton_desasociar} asociados = {documentosAsociados} resultados={documentosEncontrados} form={formBusquedaDocumento} errors={errorsFormBusquedaDocumento} onChange={onChangeFormBusquedaDocumento} onClickSearch={buscarDocumentosAsociados}/>}
            <BasicHeaderDocumentos title="Comprobante de liquidación" url="/otros-documentos"/>
            {renderView(view)}  
            <BasicFooterDocumentos textBack={footer_textButtons().back.text} imgBack={footer_textButtons().back.icon} textNext={footer_textButtons().next.text} imgNext={footer_textButtons().next.icon} onClickBack={footer_onClickBack} onClickNext={footer_onClickNext}/>          
        </BasicLayout>
    )
}

const renderView = (view: string) => {
    switch(view){
        case 'Formularios':
            return <FormulariosCL/>
        case 'Previsualizacion':
        case 'Detalle':
            return <DTEComprobanteLiquidacion/>
    }
}